import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

// Ensure clipboard works inside modals by default.
VueClipboard.config.autoSetContainer = true

Vue.use(VueClipboard)

const originalCopyText = Vue.prototype.$copyText

Vue.prototype.$copyText = async function copyTextWithModalSupport(text, container) {
  let resolvedContainer = container

  if (!resolvedContainer && typeof document !== 'undefined') {
    resolvedContainer = document.querySelector('.modal.show') || document.body
  }

  const fallbackCopy = () => originalCopyText.call(this, text, resolvedContainer)

  if (typeof navigator !== 'undefined'
    && navigator.clipboard
    && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(text)
      return Promise.resolve()
    } catch (err) {
      return fallbackCopy()
    }
  }

  return fallbackCopy()
}
